const rules = {
  user: {
    static: [],
    dynamic: {
      "quickMessages:manage": (data) => {
        return data.oDataRecord.userId === data.userId
      },
      "schedules:edit": (oData) => oData.nUserId === oData.nScheduleOwnerId,
    },
  },

  supervisor: {
    static: [
      "ticket-options:deleteTicket",
      "tickets:transferTicket",
      "tickets-manager:showall",
      "contacts-page:deleteContact",
      "quickMessages:manage",
    ],
    dynamic: {
      "schedules:edit": (oData) => oData.nUserId === oData.nScheduleOwnerId,
    },
  },

  admin: {
    static: [
      "dashboard:view",
      "drawer-admin-items:view",
      "tickets:transferTicket",
      "tickets-manager:showall",
      "user-modal:editProfile",
      "user-modal:editQueues",
      "ticket-options:deleteTicket",
      "contacts-page:deleteContact",
      "connections-page:actionButtons",
      "connections-page:addConnection",
      "connections-page:editOrDeleteConnection",
      "quickMessages:manage",
      "schedules:edit",
    ],
  },
}

export default rules
